import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotRecommend() {
  const comics = getHotComics();

  return (
    <section className="py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-1">热门推荐</h2>
            <p className="text-sm text-foreground-500">千万读者共同选择的热门漫画</p>
          </div>
          <Link to="/category/all" className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
          {comics.map(comic => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}